export default "__VITE_ASSET__DAT47qaT__"